import { Message } from "primereact/message";

import { Dialog, DialogFooter, DialogHeader, Icon } from "@/ds";
import { UserContactCard } from "@/shared/components/user-contact-card";
import styles from "./toggle-user-status-dialog.module.scss";
import type { ToggleUserStatusDialogViewModel } from "./types-toggle-user-status-dialog";

/** Modais Desativar (Figma 4651:280321) e Ativar usuário (4950:61630): identidade, impacto da operação e confirmar. */
export function ToggleUserStatusDialogView({
  contato,
  desativando,
  titulo,
  subtitulo,
  mensagem,
  confirmLabel,
  isSubmitting,
  confirmar,
  cancelar,
}: ToggleUserStatusDialogViewModel) {
  return (
    <Dialog
      visible
      size="sm"
      className={styles.dialog}
      header={
        <DialogHeader
          icon="power-off"
          tone={desativando ? "danger" : "success"}
          title={titulo}
          subtitle={subtitulo}
        />
      }
      onHide={cancelar}
      locked={isSubmitting}
      footer={
        <DialogFooter
          cancelVariant="text"
          cancelTestId="toggle-user-status-cancel"
          confirmTestId="toggle-user-status-confirm"
          confirmLabel={confirmLabel}
          severity={desativando ? "danger" : undefined}
          confirmButtonProps={desativando ? undefined : { severity: "success" }}
          loading={isSubmitting}
          locked={isSubmitting}
          onConfirm={confirmar}
          onCancel={cancelar}
        />
      }
      data-testid="toggle-user-status-dialog"
    >
      <div className={styles.corpo}>
        <UserContactCard {...contato} />

        <Message
          className="p-message-block p-message-sm"
          severity={desativando ? "error" : "success"}
          icon={<Icon name="exclamation-triangle" size={16} />}
          text={mensagem}
          role={desativando ? "alert" : "status"}
          data-testid="toggle-user-status-message"
        />
      </div>
    </Dialog>
  );
}
